<lms-breadcrumb [crumbs]="[{ label: 'Metrics', icon: 'glicon-misc', route: '.' }]"></lms-breadcrumb>

<div class="margin-top">
  <gl-button color-primary text="Calcular" (onClick)="getMetrics()"></gl-button>
</div>

<div>
  <table>
    <th>Juego</th>
    <th>Matrículas accedidas</th>
    <th>Matrículas jugadas</th>
    <th>Matrículas completadas</th>
    <th>Porcentaje completadas / accedidas</th>
    <th>Porcentaje completadas / jugadas</th>
    <th>Encuestas realizadas</th>
    <th>Encuestas positivas</th>
    <th>Porcentaje encuestas positivas</th>
    <th>Nota media</th>
    <th>Duración media (en minutos)</th>

    <tr *ngFor="let item of metrics$ | async">
      <td>{{ item.name }}</td>
      <td>{{ item.numLicensesAccessed }}</td>
      <td>{{ item.numLicensesPlayed }}</td>
      <td>{{ item.numLicensesCompleted }}</td>
      <td>{{ item.percentageCompletedPerAccessed?.toFixed(2) }}</td>
      <td>{{ item.percentageCompletedPerPlayed?.toFixed(2) }}</td>
      <td>{{ item.numSurveys }}</td>
      <td>{{ item.numYes }}</td>
      <td>{{ item.percentageYes?.toFixed(2) }}</td>
      <td>{{ item.meanOpinion?.toFixed(2) }}</td>
      <td>{{ item.meanDuration?.toFixed(2) }}</td>
    </tr>
  </table>
</div>

<div [style.font-size.px]="'11'" [style.margin-top.px]="'40'">
  Notas:
  <ul>
    <li>Se considera como "accedida" una matrícula cuando el alumno ha entrado a jugar al menos una vez</li>
    <li>Se considera como "jugada" una matrícula cuando el alumno ha pasado el nivel "demo" del juego</li>
    <li>Se considera como "completada" una matrícula cuando el alumno ha terminado el juego</li>
    <li>
      Se considera como "positiva" una encuesta a la que el alumno ha respondido afirmativamente a la pregunta de si
      recomendaría el juego
    </li>
    <li>
      Las matrículas canceladas y las matrículas "no usadas" no se tienen en cuenta a la hora de generar los cálculos
    </li>
    <li>Los empleados de Gamelearn no se tienen en cuenta a la hora de generar los cálculos</li>
    <li>Las demos y regalos no se tienen en cuenta a la hora de generar los cálculos</li>
  </ul>
</div>
